import React, { useContext } from 'react';
import { Col, Button, Card, Accordion, Row } from 'react-bootstrap';
import Logo from '../Logo/Logo';
import { Link } from 'react-router-dom';
import game from '../../util/game.util';
import { StarFill, Check, ArrowBarLeft } from 'react-bootstrap-icons';
import { GameContext } from '../../context/game.context';
import LinkButton from '../LinkButton/LinkButton';

const TopicSelector = () => {
    const gameContext = useContext(GameContext);
    const save = gameContext.save;

    return (
        <>
            <Col lg="6" sm className='p-3'>
                <Logo />
                <div className='quote-container'>
                    {/* <h2 className="text-center">Select a Topic</h2> */}
                    {/* <p>Think you know where most Americans stand on today’s big issues? Here’s your chance to test it! Dive in, share your views, then guess how others across the country feel. After each round, discover how your opinions compare to people across the nation.</p> */}
                    {/* <p>Get ready to challenge your assumptions and uncover surprising insights.</p> */}

                    {/* <p className='text-center fw-bold'>Can you guess what Americans really think?</p>
                    <p className='text-center'>Answer a few quick questions, then guess how others across the country feel. See where your views line up.</p>
                    <p className='text-center fw-bold'>The results might surprise you!</p> */}

                    <p className='text-center'>Answer a few quick questions—then guess how others might respond.</p>
                    <p className='text-center fw-bold'>See how your answers compare across the country.</p>
                </div>
                <Row className="mt-4" xs={1} md={2}>
                    {
                        Object.keys(game).map((topic, i) =>
                            <Col className={game[topic].questions.length === 0 ? 'opacity-50' : ''}>
                                <Link
                                    to={save[topic].onResults ? `/topic/${topic}/results` : `/topic/${topic}/0`}
                                    style={{ pointerEvents: game[topic].questions.length === 0 ? 'none' : undefined }}
                                    key={i}
                                >
                                    <Button
                                        variant="light"
                                        key={i}
                                        style={{ position: 'relative', width: '100%' }}
                                        className={`topic-button mx-1 mb-2 px-4`} // ${save[topic].onResults ? 'text-muted' : ''}
                                    >

                                        {/* <span className='topic-icon'>{game[topic].icon}</span> */}<span className='topic-title'>{topic}</span>
                                        <small className="questions-answered">({save?.[topic]?.onQuestion ?? 0}/{game[topic].questions.length} Answered)</small>
                                        {save[topic].onResults ? <CompletedBadge /> : ''}

                                    </Button>
                                </Link>
                            </Col>
                        )
                    }
                </Row>
                <Accordion id='about-our-data'>
                    <Accordion.Header>Learn about how our data was collected</Accordion.Header>
                    <Accordion.Body>
                        <p>The survey was fielded September 23 - October 1, 2024 with 4,640 adults by the <a href='https://publicconsultation.org/' target='_blank'>Program for Public Consultation</a> at the University of Maryland’s School of Public Policy, including approximately 600 in each state of Arizona, Georgia, Michigan, Nevada, Pennsylvania and Wisconsin, and 1,216 nationally. Samples were obtained from multiple online opt-in panels, including Cint, Dynata and Prodege. Sample collection and quality control was managed by QuantifyAI under the direction of the Program for Public Consultation. Samples were pre-stratified and weighted by age, race, gender, education, income, metro/non-metro, marital status, home ownership, and partisan affiliation (nationally and in some states) to match the general adult population. The survey was offered in both English and Spanish. The confidence interval for the national sample is +/- 3.2%, and for the state samples it ranges from +/- 4.5 to 4.6%.</p>
                        {/* <Button variant="primary">Go somewhere</Button> */}
                    </Accordion.Body>
                </Accordion>
            </Col>
        </>
    );
}

const CompletedBadge = () => {
    return (
        <div className="completed-badge">
            <StarFill size={'2rem'} />
            <Check size={'1.5rem'} />
        </div>
    )
}

export default TopicSelector;
